// Redux Utils
import { useDispatch, useSelector } from "react-redux";
import { registerUser } from "@/features/register/registerThunks";
import { registerReset } from "@/features/register/registerSlice";

// React Utils
import { useState, useRef, useEffect } from "react";
import { Navigate } from "react-router-dom";
// Paquetes
import { Country, State } from 'country-state-city';
// assets
import SignInImage from "@/assets/FormSignIn.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion as Motion, AnimatePresence } from "framer-motion";
// components
import Tooltip from "@/components/Tooltip";

const GENDERS = [
  { label: "Soy Mujer", value: "mujer" },
  { label: "Soy Hombre", value: "hombre" },
  { label: "Otros", value: "otro" },
];

const MONTHS = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export default function Register({ onBackToSignInClick }) {
  // redux dispatch
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { sendRegister, failureRegister, loading, error } = useSelector(
    (state) => state.register
  );
  console.log(
    "sendRegister:",
    sendRegister,
    "failureRegister:",
    failureRegister,
    "error:",
    error
  );

  const [form, setForm] = useState({
    gender: "mujer",
    name: "",
    lastname: "",
    country: "",
    city: "",
    day: "1",
    month: "Enero",
    year: "2000",
    email: "",
    password: "",
    repeatPassword: "",
    ambassador: false,
    bussiness: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const passwordInputRef = useRef(null);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const confirmPasswordInputRef = useRef(null);
  const [errors, setErrors] = useState({});

  // Estados para ubicación
  const [availableCountries, setAvailableCountries] = useState([]);
  const [availableStates, setAvailableStates] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);

  // Cargar países al montar
  useEffect(() => {
    const allCountries = Country.getAllCountries();
    // Próximos: 'GT', 'MX', 'AR', 'PE', 'CO'
    const allowedCountryCodes = ['CL'];
    const countries = allCountries.filter(country => 
      allowedCountryCodes.includes(country.isoCode)
    );
    setAvailableCountries(countries);
  }, []);

  // Manejar cambio de país
  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    const country = availableCountries.find(c => c.isoCode === countryCode);
    
    setSelectedCountry(country);
    setSelectedState(null);
    setForm(prev => ({ 
      ...prev, 
      country: country ? country.name : '',
      city: ''
    }));
    
    if (country) {
      const states = State.getStatesOfCountry(country.isoCode);
      setAvailableStates(states);
    } else {
      setAvailableStates([]);
    }
  };

  // Manejar cambio de región/estado
  const handleStateChange = (e) => {
    const stateCode = e.target.value;
    const state = availableStates.find(s => s.isoCode === stateCode);
    
    setSelectedState(state);
    setForm(prev => ({ 
      ...prev, 
      city: state ? state.name : ''
    }));
  };

  // Validación básica
  const validate = () => {
    const newErrors = {};
    if (!form.name) newErrors.name = "Campo requerido";
    if (!form.lastname) newErrors.lastname = "Campo requerido";
    if (!selectedCountry) newErrors.country = "Campo requerido";
    if (!selectedState) newErrors.city = "Campo requerido";
    if (!form.email) newErrors.email = "Campo requerido";
    // Validar formato de email
    if (form.email && !/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = "El email no es válido";
    }
    if (!form.password) newErrors.password = "Campo requerido";
    // Validar formato de contraseña, con los siguientes requisitos:
    // Al menos 8 caracteres, al menos una mayúscula, una minúscula, un número y un símbolo
    if (form.password && form.password.length < 8)
      newErrors.password = "La contraseña debe tener al menos 8 caracteres";
    if (form.password && !/[A-Z]/.test(form.password))
      newErrors.password =
        "La contraseña debe tener al menos una letra mayúscula";
    if (form.password && !/[a-z]/.test(form.password))
      newErrors.password =
        "La contraseña debe tener al menos una letra minúscula";
    if (form.password && !/[0-9]/.test(form.password))
      newErrors.password = "La contraseña debe tener al menos un número";
    if (form.password && !/[!@#$%^&*(),.?":{}|<>]/.test(form.password))
      newErrors.password = "La contraseña debe tener al menos un símbolo";
    if (!form.repeatPassword) newErrors.repeatPassword = "Campo requerido";
    // Validar que las contraseñas coincidan
    if (form.password !== form.repeatPassword)
      newErrors.repeatPassword = "Las contraseñas no coinciden";
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = validate();
    console.log(newErrors);
    setErrors(newErrors);

    const bornDate =
      form.year + "-" + (MONTHS.indexOf(form.month) + 1) + "-" + form.day;
    console.log(bornDate);

    if (Object.keys(newErrors).length === 0) {
      // Aquí iría la lógica de registro
      dispatch(
        registerUser({
          nombre: form.name,
          apellido: form.lastname,
          numeroTributario: null,
          correo: form.email,
          telefono: null,
          fechaNacimiento: bornDate,
          genero: form.gender,
          imagenDePerfil: null,
          enabled: 1,
          perEmpresa: form.bussiness ? 1 : 1,
          perEmbajador: form.ambassador ? 0 : 0,
          perValidador: 0,
          facebook: null,
          instagram: null,
          tiktok: null,
          pais: form.country,
          ciudad: form.city,
          password: form.password,
        })
      );
    }
  };
  if (isAuthenticated) return <Navigate to="/" replace />;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 bg-aw-bgbluedark-30 rounded-lg max-h-[90vh] overflow-y-auto sm:overflow-hidden shadow-lg">
      <div className="relative p-8 flex flex-col justify-center bg-aw-bluedark rounded-b-rounded-t-2xl sm:rounded-r-rounded-t-2xl text-white">
        <span onClick={onBackToSignInClick} className="absolute left-3 top-3">
          <FontAwesomeIcon
            icon={"fa-solid fa-arrow-left"}
            className="text-white hover:text-gray-400 duration-200 font-bold text-xl cursor-pointer"
          />
        </span>
        <div className="relative z-10">
          {sendRegister == false ? (
            <form
              className="flex flex-col gap-2 shadow-2xl"
              onSubmit={handleSubmit}
            >
              <div className="flex justify-center gap mb-2">
                <h3 className="text-xl font-semibold text-center">
                  Registrarme en AppWhoop Ticket
                </h3>
              </div>

              <div className="flex gap-2">
                <div className="flex-1">
                  <input
                    type="text"
                    name="name"
                    placeholder="Nombre"
                    value={form.name}
                    onChange={handleChange}
                    className="w-full rounded-lg px-4 py-1 bg-white/90 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-aw-green"
                  />
                  {errors.name && (
                    <span className="text-xs text-red-500">{errors.name}</span>
                  )}
                </div>
                <div className="flex-1">
                  <input
                    type="text"
                    name="lastname"
                    placeholder="Apellidos"
                    value={form.lastname}
                    onChange={handleChange}
                    className="w-full rounded-lg px-4 py-1 bg-white/90 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-aw-green"
                  />
                  {errors.lastname && (
                    <span className="text-xs text-red-500">
                      {errors.lastname}
                    </span>
                  )}
                </div>
              </div>

              {/* TODO: Agregar opción de seleccionar país y ciudad por selects */}
              <div className="flex gap-2">
                <div className="flex-1">
                  <select
                    name="country"
                    value={selectedCountry?.isoCode || ''}
                    onChange={handleCountryChange}
                    className="w-full rounded-lg px-4 py-1.5 bg-white/90 text-black focus:outline-none focus:ring-2 focus:ring-aw-green"
                  >
                    <option value="">País</option>
                    {availableCountries.map((country) => (
                      <option key={country.isoCode} value={country.isoCode}>
                        {country.flag} {country.name}
                      </option>
                    ))}
                  </select>
                  {errors.country && (
                    <span className="text-xs text-red-500">
                      {errors.country}
                    </span>
                  )}
                </div>
                <div className="flex-1">
                  <select
                    name="city"
                    value={selectedState?.isoCode || ''}
                    onChange={handleStateChange}
                    disabled={!selectedCountry}
                    className="w-full rounded-lg px-4 py-1.5 bg-white/90 text-black focus:outline-none focus:ring-2 focus:ring-aw-green disabled:bg-gray-300 disabled:cursor-not-allowed"
                  >
                    <option value="">Región</option>
                    {availableStates.map((state) => (
                      <option key={state.isoCode} value={state.isoCode}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                  {errors.city && (
                    <span className="text-xs text-red-500">{errors.city}</span>
                  )}
                </div>
              </div>
              <div className="flex justify-center gap-4 my-1">
                {GENDERS.map((g) => (
                  <label
                    key={g.value}
                    className="flex items-center gap-2 text-white"
                  >
                    <input
                      type="radio"
                      name="gender"
                      value={g.value}
                      checked={form.gender === g.value}
                      onChange={handleChange}
                      className="accent-aw-green"
                    />
                    {g.label}
                  </label>
                ))}
              </div>
              <label className="flex items-center gap-2 text-white text-xs">
                Fecha de Nacimiento
                <Tooltip
                  content="Utilizaremos este dato para enviarte información, beneficios y promociones"
                  position="bottom"
                >
                  <span className="text-white">(?)</span>
                </Tooltip>
              </label>
              <div className="flex justify-between gap-2">
                <input
                  type="number"
                  name="day"
                  min="1"
                  max="31"
                  value={form.day}
                  onChange={handleChange}
                  className="w-1/5 rounded-lg px-2 py-1 bg-white/90 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-aw-green"
                />
                <select
                  name="month"
                  value={form.month}
                  onChange={handleChange}
                  className="w-3/5 rounded-lg px-2 py-1 bg-white/90 text-black focus:outline-none focus:ring-2 focus:ring-aw-green"
                >
                  {MONTHS.map((m) => (
                    <option key={m} value={m}>
                      {m}
                    </option>
                  ))}
                </select>
                <input
                  type="number"
                  name="year"
                  min="1900"
                  max={new Date().getFullYear()}
                  value={form.year}
                  onChange={handleChange}
                  className="w-1/5 rounded-lg px-2 py-1 bg-white/90 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-aw-green"
                />
              </div>
              <input
                type="email"
                name="email"
                placeholder="Correo electrónico"
                value={form.email}
                onChange={handleChange}
                className="w-full rounded-lg px-4 py-1 bg-white/90 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-aw-green"
              />
              {errors.email && (
                <span className="text-xs text-red-500">{errors.email}</span>
              )}
              <label className="flex items-center gap-1 text-white text-xs">
                Formato de contraseña
                <Tooltip
                  content="8 caracteres mínimo, incluyendo mayúsculas, minúsculas, números y símbolos"
                  position="bottom"
                >
                  <span className="text-white">(?)</span>
                </Tooltip>
              </label>
              <div className="relative">
                <input
                  ref={passwordInputRef}
                  type={showPassword ? "text" : "password"}
                  name="password"
                  id="password"
                  value={form.password}
                  onChange={handleChange}
                  className="w-full px-3 py-1 border border-gray-300 rounded-md bg-white text-black focus:outline-none focus:ring-2 focus:ring-aw-bluedark pr-10"
                  placeholder="Contraseña"
                />
                <button
                  type="button"
                  className="h-full w-1/12 absolute top-0 right-1 flex justify-center items-center text-gray-500 hover:text-aw-bluedark focus:outline-none duration-200 px-2"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => {
                    // Guardar posición del cursor
                    const input = passwordInputRef.current;
                    const start = input.selectionStart;
                    const end = input.selectionEnd;
                    setShowPassword((prev) => !prev);
                    setTimeout(() => {
                      input.focus();
                      input.setSelectionRange(start, end);
                    }, 0);
                  }}
                  tabIndex={-1}
                >
                  <AnimatePresence>
                    <Motion.div
                      key={showPassword ? "eye-slash" : "eye"}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.5 }}
                    >
                      <FontAwesomeIcon
                        icon={
                          showPassword
                            ? "fa-regular fa-eye-slash"
                            : "fa-regular fa-eye"
                        }
                        className="absolute top-2.5 right-3"
                      />
                    </Motion.div>
                  </AnimatePresence>
                </button>
              </div>
              {errors.password && (
                <span className="text-xs text-red-500">{errors.password}</span>
              )}
              <div className="relative">
                <input
                  ref={confirmPasswordInputRef}
                  type={showConfirmPassword ? "text" : "password"}
                  name="repeatPassword"
                  id="repeatPassword"
                  value={form.repeatPassword}
                  onChange={handleChange}
                  className="w-full px-3 py-1 border border-gray-300 rounded-md bg-white text-black focus:outline-none focus:ring-2 focus:ring-aw-bluedark pr-10"
                  placeholder="Confirmar Contraseña"
                />
                <button
                  type="button"
                  className="h-full w-1/12 absolute top-0 right-1 flex justify-center items-center text-gray-500 hover:text-aw-bluedark focus:outline-none duration-200 px-2"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => {
                    // Guardar posición del cursor
                    const input = confirmPasswordInputRef.current;
                    const start = input.selectionStart;
                    const end = input.selectionEnd;
                    setShowConfirmPassword((prev) => !prev);
                    setTimeout(() => {
                      input.focus();
                      input.setSelectionRange(start, end);
                    }, 0);
                  }}
                  tabIndex={-1}
                >
                  <AnimatePresence>
                    <Motion.div
                      key={showConfirmPassword ? "eye-slash" : "eye"}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.5 }}
                    >
                      <FontAwesomeIcon
                        icon={
                          showConfirmPassword
                            ? "fa-regular fa-eye-slash"
                            : "fa-regular fa-eye"
                        }
                        className="text-base absolute top-2.5 right-3"
                      />
                    </Motion.div>
                  </AnimatePresence>
                </button>
              </div>
              {errors.repeatPassword && (
                <span className="text-xs text-red-500">
                  {errors.repeatPassword}
                </span>
              )}
              {/* <label className="flex items-center gap-2 text-white text-sm">
                <input
                  type="checkbox"
                  name="ambassador"
                  checked={form.ambassador}
                  onChange={handleChange}
                  className="accent-aw-green"
                />
                Quiero postular para ser Embajador
                <Tooltip
                  content="Quieres trabajar promoviendo eventos, te enviaremos un correo para confirmar tu solicitud luego de que confirmes tu perfil"
                  position="bottom"
                >
                  <span className="text-white">(?)</span>
                </Tooltip>
              </label>
              <label className="flex items-center gap-2 text-white text-sm mb-2">
                <input
                  type="checkbox"
                  name="bussiness"
                  checked={form.bussiness}
                  onChange={handleChange}
                  className="accent-aw-green"
                />
                Quiero aperturar una Empresa
                <Tooltip
                  content="Quieres publicar una tickets sobre tus eventos, te enviaremos un correo y una notifiación al confirmar tu perfil usuario"
                  position="bottom"
                >
                  <span className="text-white">(?)</span>
                </Tooltip>
              </label> */}

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-aw-green text-black font-semibold py-1 rounded-full flex items-center justify-center gap-2 text-lg shadow-lg transition-scale duration-300 hover:scale-95 disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:scale-100"
              >
                <FontAwesomeIcon
                  icon={loading ? "fa-solid fa-circle-notch" : "fa-solid fa-user-circle"}
                  className={`text-xl${loading ? " animate-spin" : ""}`}
                />
                {loading ? "Enviando..." : "Registrarme"}
              </button>
              {/* divisor */}
              <hr className=" mt-2 border-t border-aw-bluegray" />
              {/* <div className="flex items-center justify-center gap-2">
                <span className="text-xs">O puedes activar tu perfil con:</span>
                <FontAwesomeIcon
                  icon="fa-brands fa-apple"
                  className="text-xl transition-scale bg-aw-green text-aw-dark rounded-full py-2 px-2.5 duration-300 transition-scale hover:scale-85 cursor-pointer"
                />
                <FontAwesomeIcon
                  icon="fa-brands fa-google"
                  className="fa-google-css text-xl transition-scale bg-aw-green text-aw-dark rounded-full py-2 px-2.5 duration-300 transition-scale hover:scale-85 cursor-pointer"
                />
              </div> */}

              <div className="text-xs text-white text-center mt-2">
                Al hacer clic en "Registrarme", acepta nuestra 
                <br />
                <a 
                href="/politica-de-privacidad-y-terminos-y-condiciones"
                className="underline cursor-pointer">
                  Política de Privacidad y Terminos y condiciones.
                </a>
              </div>
              <div className="text-xs text-white text-center mt-2">
                Puede recibir nuestras notificaciones por correo y puede optar
                por no recibirlas en cualquier momento.
              </div>
              <div className="text-xs text-white text-center mt-2">
                © {new Date().getFullYear()} AppWhoop Ticket. Todos los derechos reservados
              </div>
            </form>
          ) : error ? (
            <div className="text-red-500 text-center mt-2">
              <FontAwesomeIcon
                icon="fa-solid fa-circle-exclamation"
                className="text-4xl mx-auto mb-2 animate-bounce"
              />
              <h4 className="text-2xl text-gray-300 font-semibold">
                {error.message}
              </h4>
              <button
                onClick={() => dispatch(registerReset())}
                className="mt-4 px-4 py-2 bg-aw-green text-aw-dark rounded-lg font-semibold hover:bg-aw-green/90 hover:scale-95 transition-transform duration-300"
              >
                Intentar de nuevo
              </button>
            </div>
          ) : (
            <div className="text-aw-green text-center mt-2">
              <FontAwesomeIcon
                icon="fa-solid fa-circle-check"
                className="text-4xl mx-auto mb-2 animate-bounce"
              />
              <h4 className="text-4xl text-gray-300 font-semibold">
                Registro Exitoso!
              </h4>
              <p className="mt-2">
                Por favor, revisa tu correo electrónico para confirmar tu cuenta ANTES DE INICIAR SESIÓN POR PRIMERA VEZ.
              </p>
              <button
                onClick={() => {
                  dispatch(registerReset());
                  onBackToSignInClick();
                }}
                className="mt-4 px-4 py-2 bg-aw-green text-aw-dark rounded-lg font-semibold hover:bg-aw-green/90 hover:scale-95 transition-transform duration-300"
              >
                Volver a Iniciar Sesión
              </button>
            </div>
          )}
        </div>
        {/* Mobile background image with overlay */}
        <div className="absolute inset-0 sm:hidden">
          <img
            src={SignInImage}
            alt="Sign In"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-aw-bluedark-75 backdrop-blur-[1.5px]" />
        </div>
      </div>
      <div className="hidden sm:block relative w-full h-full border-2 sm:rounded-r-2xl">
        <img
          src={SignInImage}
          alt="Sign In"
          className="w-full h-full object-cover object-center"
        />
      </div>
    </div>
  );
}
